import { useStaticQuery, graphql } from 'gatsby'

export function useDataSloganByEn() {
    const data = useStaticQuery(graphql`
        {
            title: datoCmsRenshinPageAbout(title: { eq: "Quote" }, locale: { eq: "en" }) {
                value
            }

            heroImage: datoCmsRenshinPageAbout(title: { eq: "Quote: Image" }, locale: { eq: "en" }) {
                image: heroimage {
                    url
                }
            }
        }
    `)

    return data
}
